import React from 'react';

export const Logo = () => {
  return (
    <>

      <div
        style={{
          position: 'absolute',
          left: 127.4,
          top: 54.8,
          width: 183,
          height: 46,
          fontFamily: `'Inter Hewn', sans-serif`,
          fontStyle: 'normal',
          fontWeight: 700,
          fontSize: 38.4,
          lineHeight: '46px',
          color: '#FFFFFF',
        }}
      >
        For<span style={{ color: 'transparent', background: 'linear-gradient(to right, #6D1D7D, #5F0BE8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Matrix</span>
      </div>
    </>
  );
};